import { createDate } from '@unistocks/shared/utils/util';
import { WeekdayNumbers } from 'luxon';
import type { DateStringValue } from '../../types';

/**
 * Walks backwards from `date` to the first preceding day whose weekday matches
 * `firstDayOfWeek`, returning it as a `yyyy-MM-dd` string. Mirrors
 * @mantine/dates `getStartOfWeek`.
 */
export function getStartOfWeek(
  date: DateStringValue,
  firstDayOfWeek: WeekdayNumbers = 1
): DateStringValue {
  let value = createDate(date).startOf('week');
  while (value.weekday !== firstDayOfWeek) {
    value = value.plus({ day: 1 });
  }

  return value.toISODate();
}
